import api from "./axios";
import { API_ENDPOINTS } from "../constants";
import { logError } from "../common/utils/logger";
import { encryptJourneyQueryValue } from "../common/utils/journeyEncryption";

const RESUME_DOB_SESSION_KEY = "rnlic_resumeDob";
const getResumeDobStorageKey = (applicationNumber) =>
  `${RESUME_DOB_SESSION_KEY}:${String(applicationNumber || "").trim()}`;

const readStoredResumeDob = (applicationNumber) => {
  try {
    const dob =
      (applicationNumber
        ? sessionStorage.getItem(getResumeDobStorageKey(applicationNumber))
        : null) ||
      sessionStorage.getItem(RESUME_DOB_SESSION_KEY);
    return typeof dob === "string" && dob.trim() ? dob.trim() : null;
  } catch {
    return null;
  }
};

/**
 * Fetch policy status before OTP verification
 */
export const getPolicyStatus = async (applicationNumber) => {
  try {
    if (!applicationNumber) {
      throw new Error("applicationNumber is required");
    }

    const dateOfBirth = readStoredResumeDob(applicationNumber);
    const response = await api.get(API_ENDPOINTS.GET_POLICY_STATUS, {
      params: {
        applicationNumber: encryptJourneyQueryValue(applicationNumber),
        ...(dateOfBirth ? { dateOfBirth: encryptJourneyQueryValue(dateOfBirth) } : {})
      }
    });

    return response?.data ?? null;

  } catch (error) {
    logError("[getPolicyStatus] Failed", error);
    throw error;
  }
};